import React from 'react'
import type { Question } from './index'
import { Code, CodeBlock, Title } from '../components/QuestionsTitle'

export const Logo = (props: { className: string }) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" version="1.2" viewBox="0 0 442.37 270.929">
    <defs />
    <defs>
      <linearGradient id="b" x1="-.348" x2="1.251" gradientTransform="rotate(116.114 53.1 202.97) scale(86.48)" gradientUnits="userSpaceOnUse">
        <stop offset=".3" stopColor="#3E863D" />
        <stop offset=".5" stopColor="#55934F" />
        <stop offset=".8" stopColor="#5AAD45" />
      </linearGradient>
      <linearGradient id="d" x1="-.456" x2=".582" gradientTransform="rotate(-36.46 550.846 -214.337) scale(132.798)" gradientUnits="userSpaceOnUse">
        <stop offset=".57" stopColor="#3E863D" />
        <stop offset=".72" stopColor="#619857" />
        <stop offset="1" stopColor="#76AC64" />
      </linearGradient>
      <linearGradient id="f" x1=".043" x2=".984" gradientTransform="translate(192.862 279.652) scale(97.417)" gradientUnits="userSpaceOnUse">
        <stop offset=".16" stopColor="#6BBF47" />
        <stop offset=".38" stopColor="#79B461" />
        <stop offset=".47" stopColor="#75AC64" />
        <stop offset=".7" stopColor="#659E5A" />
        <stop offset=".9" stopColor="#3E863D" />
      </linearGradient>
      <clipPath id="a">
        <path d="M239.03 226.605l-42.13 24.317a5.085 5.085 0 00-2.546 4.406v48.668c0 1.817.968 3.496 2.546 4.406l42.133 24.336a5.1 5.1 0 005.09 0l42.126-24.336a5.096 5.096 0 002.54-4.406v-48.668c0-1.816-.97-3.496-2.55-4.406l-42.12-24.317a5.123 5.123 0 00-5.1 0" />
      </clipPath>
      <clipPath id="c">
        <path d="M195.398 307.086c.403.523.907.976 1.5 1.316l36.14 20.875 6.02 3.46c.9.52 1.926.74 2.934.665.336-.027.672-.09 1-.183l44.434-81.36c-.34-.37-.738-.68-1.184-.94l-27.586-15.93-14.582-8.39a5.318 5.318 0 00-1.32-.53zm0 0" />
      </clipPath>
      <clipPath id="e">
        <path d="M241.066 225.953a5.14 5.14 0 00-2.035.652l-42.01 24.247 45.3 82.51c.63-.09 1.25-.3 1.81-.624l42.13-24.336a5.105 5.105 0 002.46-3.476l-46.18-78.89a5.29 5.29 0 00-1.03-.102c-.14 0-.28.007-.42.02" />
      </clipPath>
    </defs>
    <path fill="#689f63" d="M218.647 270.93c-1.46 0-2.91-.383-4.19-1.12l-13.337-7.896c-1.992-1.114-1.02-1.508-.363-1.735 2.656-.93 3.195-1.14 6.03-2.75.298-.17.688-.11.993.07l10.246 6.08c.37.2.895.2 1.238 0l39.95-23.06c.37-.21.61-.64.61-1.08v-46.1c0-.46-.24-.87-.618-1.1l-39.934-23.04c-.37-.22-.86-.22-1.23 0l-39.926 23.04c-.387.22-.633.65-.633 1.09v46.1c0 .44.24.86.62 1.07l10.94 6.32c5.94 2.97 9.57-.53 9.57-4.05v-45.5c0-.65.51-1.15 1.16-1.15h5.06c.63 0 1.15.5 1.15 1.15v45.52c0 7.92-4.32 12.47-11.83 12.47-2.31 0-4.13 0-9.21-2.5l-10.48-6.04a8.447 8.447 0 01-4.19-7.29v-46.1c0-3 1.6-5.8 4.19-7.28l39.99-23.07c2.53-1.43 5.89-1.43 8.4 0l39.94 23.08a8.428 8.428 0 014.19 7.28v46.1c0 2.99-1.61 5.78-4.19 7.28l-39.94 23.07a8.397 8.397 0 01-4.21 1.12" />
    <path fill="#689f63" d="M230.987 239.164c-17.48 0-21.145-8.024-21.145-14.754 0-.64.516-1.15 1.157-1.15h5.16c.57 0 1.05.415 1.14.978.78 5.258 3.1 7.91 13.67 7.91 8.42 0 12-1.902 12-6.367 0-2.57-1.02-4.48-14.1-5.76-10.94-1.08-17.7-3.49-17.7-12.24 0-8.06 6.8-12.86 18.19-12.86 12.79 0 19.13 4.44 19.93 13.98a1.164 1.164 0 01-1.16 1.26h-5.19c-.54 0-1.01-.38-1.12-.9-1.25-5.53-4.27-7.3-12.48-7.3-9.19 0-10.26 3.2-10.26 5.6 0 2.91 1.26 3.76 13.66 5.4 12.28 1.63 18.11 3.93 18.11 12.56 0 8.7-7.26 13.69-19.92 13.69m48.66-48.89h1.34c1.1 0 1.31-.77 1.31-1.22 0-1.18-.81-1.18-1.26-1.18h-1.38zm-1.63-3.78h2.97c1.02 0 3.02 0 3.02 2.28 0 1.59-1.02 1.92-1.63 2.12 1.19.08 1.27.86 1.43 1.96.08.69.21 1.88.45 2.28h-1.83c-.05-.4-.33-2.6-.33-2.72-.12-.49-.29-.73-.9-.73h-1.51v3.46h-1.67zm-3.57 4.3c0 3.58 2.89 6.48 6.44 6.48 3.58 0 6.47-2.96 6.47-6.48 0-3.59-2.93-6.44-6.48-6.44-3.5 0-6.44 2.81-6.44 6.43m14.16.03c0 4.24-3.47 7.7-7.7 7.7-4.2 0-7.7-3.42-7.7-7.7 0-4.36 3.58-7.7 7.7-7.7 4.15 0 7.69 3.35 7.69 7.7" />
    <path fill="#333" fillRule="evenodd" d="M94.936 90.55c0-1.84-.97-3.53-2.558-4.445l-42.356-24.37a4.946 4.946 0 00-2.328-.67h-.438c-.812.03-1.613.25-2.34.67L2.562 86.105A5.154 5.154 0 000 90.555l.093 65.64c0 .91.47 1.76 1.27 2.21.78.48 1.76.48 2.54 0l25.18-14.42c1.59-.946 2.56-2.618 2.56-4.44V108.88a5.1 5.1 0 012.555-4.43l10.72-6.174a5.086 5.086 0 012.56-.688c.876 0 1.77.226 2.544.687l10.715 6.172c1.586.91 2.56 2.6 2.56 4.43v30.663c0 1.82.983 3.5 2.565 4.44l25.164 14.41a2.5 2.5 0 002.56 0 2.568 2.568 0 001.268-2.21zm199.868 34.176c0 .457-.243.88-.64 1.106l-14.548 8.386a1.282 1.282 0 01-1.277 0l-14.55-8.386c-.4-.227-.64-.65-.64-1.106V107.93c0-.458.24-.88.63-1.11l14.54-8.4c.4-.23.89-.23 1.29 0l14.55 8.4c.4.23.64.652.64 1.11zM298.734.324a2.568 2.568 0 00-2.544.027c-.78.46-1.262 1.3-1.262 2.21v65a1.788 1.788 0 01-2.684 1.55L281.634 63a5.108 5.108 0 00-5.112 0l-42.37 24.453a5.105 5.105 0 00-2.56 4.42v48.92c0 1.83.977 3.51 2.56 4.43l42.37 24.47c1.582.91 3.53.91 5.117 0l42.37-24.48c1.58-.92 2.56-2.6 2.56-4.43V18.863a5.128 5.128 0 00-2.63-4.47zm141.093 107.164a5.116 5.116 0 002.543-4.422V91.21c0-1.824-.97-3.507-2.547-4.425l-42.1-24.44a5.113 5.113 0 00-5.13 0l-42.36 24.45c-1.59.92-2.56 2.6-2.56 4.43v48.9c0 1.84.99 3.54 2.58 4.45l42.09 23.99c1.55.89 3.45.9 5.02.03l25.46-14.15c.8-.45 1.31-1.3 1.31-2.22 0-.92-.49-1.78-1.29-2.23l-42.62-24.46c-.8-.45-1.29-1.3-1.29-2.21v-15.34c0-.916.48-1.76 1.28-2.216l13.26-7.65c.79-.46 1.76-.46 2.55 0l13.27 7.65c.79.45 1.28 1.3 1.28 2.21v12.06c0 .91.49 1.76 1.28 2.22.79.45 1.77.45 2.56-.01zm0 0" />
    <path fill="#689f63" fillRule="evenodd" d="M394.538 105.2a.97.97 0 01.98 0l8.13 4.69c.304.176.49.5.49.85v9.39c0 .35-.186.674-.49.85l-8.13 4.69a.97.97 0 01-.98 0l-8.125-4.69a.979.979 0 01-.5-.85v-9.39c0-.35.18-.674.49-.85zm0 0" />
    <g clipPath="url(#a)" transform="translate(-78.306 -164.016)">
      <path fill="url(#b)" d="M331.363 246.793l-118.715-58.19-60.87 124.174L270.49 370.97zm0 0" />
    </g>
    <g clipPath="url(#c)" transform="translate(-78.306 -164.016)">
      <path fill="url(#d)" d="M144.07 264.004l83.825 113.453 110.86-81.906-83.83-113.45zm0 0" />
    </g>
    <g clipPath="url(#e)" transform="translate(-78.306 -164.016)">
      <path fill="url(#f)" d="M197.02 225.934v107.43h91.683v-107.43zm0 0" />
    </g>
  </svg>
)

export const TITLE = 'Test NodeJS B3'

export const DURATION = 2400

export const QUESTIONS: Question[] = [
  {
    title: <Title>Quelle(s) affirmation(s) est(sont) vraie(s) ?</Title>,
    possibleAnswers: [
      { key: 'a', label: 'Les const sont scopées au bloc qui les contient.' },
      { key: 'b', label: 'Les const sont scopées à la fonction qui les contient.' },
      { key: 'c', label: 'Les let sont scopées au bloc qui les contient.' },
      { key: 'd', label: 'Les let sont scopées à la fonction qui les contient.' },
      { key: 'e', label: 'Les var sont scopées au bloc qui les contient.' },
      { key: 'f', label: 'Les var sont scopées à la fonction qui les contient.' },
    ],
  },
  {
    title: <Title>Quelle(s) affirmation(s) est(sont) vraie(s) ?</Title>,
    possibleAnswers: [
      { key: 'a', label: 'Les let peuvent être réassignées.' },
      { key: 'b', label: 'Les const peuvent être réassignées.' },
      { key: 'c', label: 'Les var peuvent être réassignées.' },
      { key: 'd', label: 'Les let sont immutables.' },
      { key: 'e', label: 'Les const sont immutables.' },
      { key: 'f', label: 'Les var sont immutables.' },
    ],
  },
  {
    title: (
      <>
        <Title>Qu'est ce qui sera loggé en console ?</Title>
        <CodeBlock code={`
          if (true) {
            let foo = 'bar';
          }

          console.log(foo)
        `}
        />
      </>
    ),
    possibleAnswers: [
      { key: 'a', label: '"undefined"' },
      { key: 'b', label: '"bar"' },
      { key: 'c', label: 'Le code throw une erreur' },
    ],
  },
  {
    title: (
      <>
        <Title>Qu'est ce qui sera loggé en console ?</Title>
        <CodeBlock code={`
          let foo;

          if (true) {
            foo = 'bar';
          }

          console.log(foo)
        `}
        />
      </>
    ),
    possibleAnswers: [
      { key: 'a', label: '"undefined"' },
      { key: 'b', label: '"bar"' },
      { key: 'c', label: 'Le code throw une erreur' },
    ],
  },
  {
    title: (
      <>
        <Title>Qu'est ce qui sera loggé en console ?</Title>
        <CodeBlock code={`
          const myObject = { test: 'bar' };

          if (true) {
            myObject.key = 'value';
          }

          console.log(myObject)
        `}
        />
      </>
    ),
    possibleAnswers: [
      { key: 'a', label: '{ test: \'bar\' }' },
      { key: 'b', label: '{ test: \'bar\', key: \'value\' }' },
      { key: 'c', label: '{ key: \'value\' }' },
      { key: 'd', label: 'Le code throw une erreur' },
    ],
  },
  {
    title: (
      <>
        <Title>Qu'est ce qui sera loggé en console ?</Title>
        <CodeBlock code={`
          const myFunction = (...params) => params

          console.log(myFunction(1, 23, 4))
        `}
        />
      </>
    ),
    possibleAnswers: [
      { key: 'a', label: '[1, 23, 4]' },
      { key: 'b', label: '[1, 2, 3 , 4]' },
      { key: 'c', label: '"1234"' },
      { key: 'd', label: 'Le code throw une erreur' },
    ],
  },
  {
    title: (
      <>
        <Title>Comment ce code peut être simplifié ?</Title>
        <CodeBlock code={`
          const myFn = (name, language) => 'Hi' + name + '! Do you like ' + language + '?';

          // Réponse A
          const myFn = (name, language) => "Hi $name! Do you like $language?";

          // Réponse B
          const myFn = (name, language) => \`Hi \${name}! Do you like \${language}?\`;

          // Réponse C
          const myFn = (name, language) => sprintf('Hi %s! Do you like %s?', name, language);
        `}
        />
      </>
    ),
    possibleAnswers: [
      { key: 'a', label: 'Réponse A' },
      { key: 'b', label: 'Réponse B' },
      { key: 'c', label: 'Réponse C' },
      { key: 'd', label: 'Il ne peut pas être simplifié' },
    ],
  },
  {
    title: (
      <>
        <Title>Qu'est ce qui sera loggé en console ?</Title>
        <CodeBlock code={`
          const myObj = { foo: 'bar' };
          const { x: y = 1 } = myObj;

          console.log(y);
        `}
        />
      </>
    ),
    possibleAnswers: [
      { key: 'a', label: '{ foo: \'bar\' }' },
      { key: 'b', label: '\'bar\'' },
      { key: 'c', label: '1' },
      { key: 'd', label: 'undefined' },
    ],
  },
  {
    title: (
      <>
        <Title>Qu'est ce qui sera loggé en console ?</Title>
        <CodeBlock code={`
          const myObj = { foo: 'bar' };
          const { foo = 1 } = myObj;

          console.log(foo);
        `}
        />
      </>
    ),
    possibleAnswers: [
      { key: 'a', label: '{ foo: \'bar\' }' },
      { key: 'b', label: '\'bar\'' },
      { key: 'c', label: '1' },
      { key: 'd', label: 'undefined' },
    ],
  },
  {
    title: (
      <>
        <Title>Qu'est ce qui sera loggé en console ?</Title>
        <CodeBlock code={`
          const apiCall = require('./myApi') // une fonction qui fait un appel api vers un service distant.

          let foo = 'bar';

          apiCall().then(() => foo = 'baz')

          console.log(foo);
        `}
        />
      </>
    ),
    possibleAnswers: [
      { key: 'a', label: "'bar'" },
      { key: 'b', label: 'Promise { <pending> }' },
      { key: 'c', label: "'baz'" },
      { key: 'd', label: 'undefined' },
    ],
  },
  {
    title: (
      <>
        <Title>Qu'est ce qui sera loggé en console ?</Title>
        <CodeBlock code={`
          const apiCall = require('./myApi') // une fonction qui fait un appel api vers un service distant.

          const myFunction = async () => {
            await apiCall();

            return 'foo';
          }

          console.log(myFunction());
        `}
        />
      </>
    ),
    possibleAnswers: [
      { key: 'a', label: "'foo'" },
      { key: 'b', label: 'Promise { <pending> }' },
      { key: 'c', label: '[Function: foo]' },
      { key: 'd', label: 'Le code throw une erreur.' },
    ],
  },
  {
    title: (
      <>
        <Title>Comment puis-je refactorer ce code ?</Title>
        <CodeBlock code={`
          const foo = function () {
            return { foo: 'bar' }
          }

          // Réponse A
          const foo = () => { return { foo: 'bar' } }

          // Réponse B
          const foo = () => { foo: 'bar' }

          // Réponse C
          const foo = () => {{ foo: 'bar' }}

          // Réponse D
          const foo = () => ({ foo: 'bar' })
        `}
        />
      </>
    ),
    possibleAnswers: [
      { key: 'a', label: 'Réponse A' },
      { key: 'b', label: 'Réponse B' },
      { key: 'c', label: 'Réponse C' },
      { key: 'd', label: 'Réponse D' },
    ],
  },
  {
    title: (
      <>
        <Title>Qu'est ce qui sera loggé en console ?</Title>
        <CodeBlock code={`
          let a = 'foo';
          let b = 'bar';

          [a, b] = [b, a];

          console.log(a, b);
        `}
        />
      </>
    ),
    possibleAnswers: [
      { key: 'a', label: 'foo bar' },
      { key: 'b', label: 'bar foo' },
      { key: 'c', label: "['foo', 'bar']" },
      { key: 'd', label: "['bar', 'foo']" },
      { key: 'e', label: 'Le code throw une erreur.' },
    ],
  },
  {
    title: (
      <>
        <Title>Qu'est ce qui sera loggé en console ?</Title>
        <CodeBlock code={`
          const a = 'foo';
          const b = 'bar';

          [a, b] = [b, a];

          console.log(a, b);
        `}
        />
      </>
    ),
    possibleAnswers: [
      { key: 'a', label: 'foo bar' },
      { key: 'b', label: 'bar foo' },
      { key: 'c', label: "['foo', 'bar']" },
      { key: 'd', label: "['bar', 'foo']" },
      { key: 'e', label: 'Le code throw une erreur.' },
    ],
  },
  {
    title: (
      <>
        <Title>Qu'est ce qui sera loggé en console ?</Title>
        <CodeBlock code={`
          const a = 'foo';
          const b = 'bar';

          console.log({ a, b });
        `}
        />
      </>
    ),
    possibleAnswers: [
      { key: 'a', label: 'foo bar' },
      { key: 'b', label: 'bar foo' },
      { key: 'c', label: "{ a: 'foo', b: 'bar' }" },
      { key: 'd', label: 'Le code throw une erreur.' },
    ],
  },
  {
    title: (
      <>
        <Title>Qu'est ce qui sera loggé en console en exécutant <Code>node bar.js</Code> ?</Title>
        <CodeBlock code={`
          // Dans le fichier foo.js
          export const 'foo';

          // Dans le fichier bar.js
          import { foo } from './foo.js'

          console.log(foo);
        `}
        />
      </>
    ),
    possibleAnswers: [
      { key: 'a', label: 'foo' },
      { key: 'b', label: 'undefined' },
      { key: 'c', label: "{ foo: 'foo' }" },
      { key: 'd', label: 'Le code throw une erreur.' },
    ],
  },
  {
    title: (
      <>
        <Title>Qu'est ce qui sera loggé en console ?</Title>
        <CodeBlock code={`
          const point = [1, 3];
          const segment = [point, [5, 5]];
          const triangle = [...segment, [1, 8]];

          console.log(triangle);
        `}
        />
      </>
    ),
    possibleAnswers: [
      { key: 'a', label: '23' },
      { key: 'b', label: '[1, 3, 5, 5, 1, 8]' },
      { key: 'c', label: '[[1,3], [5,5], [1,8]]' },
      { key: 'd', label: 'Le code throw une erreur.' },
    ],
  },
  {
    title: (
      <>
        <Title>Qu'est ce qui sera loggé en console ?</Title>
        <CodeBlock code={`
          const foo = ['My', 'favorite', 'language', 'is', 'Javascript', '!'];

          console.log(...foo);
        `}
        />
      </>
    ),
    possibleAnswers: [
      { key: 'a', label: "['My', 'favorite', 'language', 'is', 'Javascript', '!']" },
      { key: 'b', label: "'My favorite language is Javascript!'" },
      { key: 'c', label: "{ foo: ['My', 'favorite', 'language', 'is', 'Javascript', '!'] }" },
      { key: 'd', label: 'Le code throw une erreur.' },
    ],
  },
  {
    title: (
      <>
        <Title>Qu'est ce qui sera loggé en console ?</Title>
        <CodeBlock code={`
          const users = [{ firstName: 'Mathieu' }, { firstName: 'Alex' }];

          const msg = users
            ? users.map(({ firstName }) => firstName).join(', ')
            : 'Pas d\\'utilisateur';

          console.log(msg)
        `}
        />
      </>
    ),
    possibleAnswers: [
      { key: 'a', label: "'Mathieu, Alex'" },
      { key: 'b', label: "'Pas d\\'utilisateur'" },
      { key: 'c', label: "''" },
      { key: 'd', label: 'Le code throw une erreur' },
    ],
  },
  {
    title: (
      <>
        <Title>Qu'est ce qui sera loggé en console ?</Title>
        <CodeBlock code={`
          const users = [];

          const msg = users
            ? users.map(({ firstName }) => firstName).join(', ')
            : 'Pas d\\'utilisateur';

          console.log(msg)
        `}
        />
      </>
    ),
    possibleAnswers: [
      { key: 'a', label: "'Mathieu, Alex'" },
      { key: 'b', label: "'Pas d\\'utilisateur'" },
      { key: 'c', label: "''" },
      { key: 'd', label: 'Le code throw une erreur' },
    ],
  },
  {
    title: (
      <>
        <Title>Qu'est ce qui sera loggé en console ?</Title>
        <CodeBlock code={`
          const users = [{ firstName: 'Mathieu' }, { firstName: 'Alex' }];

          console.log(users.filter(({ firstName }) => firstName.include('x')));
        `}
        />
      </>
    ),
    possibleAnswers: [
      { key: 'a', label: "'Mathieu, Alex'" },
      { key: 'b', label: "[{ firstName: 'Alex' }]" },
      { key: 'c', label: '[true, false]' },
      { key: 'd', label: 'Le code throw une erreur' },
    ],
  },
  {
    title: (
      <>
        <Title>Qu'est ce qui sera loggé en console ?</Title>
        <CodeBlock code={`
          const foo = [1, 2, 3];
          const bar = foo;

          foo.push(4);

          console.log(bar);
        `}
        />
      </>
    ),
    possibleAnswers: [
      { key: 'a', label: '[1, 2, 3]' },
      { key: 'b', label: '[1, 2, 3, 4]' },
      { key: 'c', label: 'foo' },
    ],
  },
  {
    title: (
      <>
        <Title>Qu'est ce qui sera loggé en console ?</Title>
        <CodeBlock code={`
          const foo = [1, 2, 3];
          const bar = [...foo];

          foo.push(4);

          console.log(bar);
        `}
        />
      </>
    ),
    possibleAnswers: [
      { key: 'a', label: '[1, 2, 3]' },
      { key: 'b', label: '[1, 2, 3, 4]' },
      { key: 'c', label: 'foo' },
    ],
  },

].map((question, i) => ({
  ...question,
  id: `node-${i + 1}`,
}))
